import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import CheckIcon from '../../icons/component-lib.esm14.js';
import MinusIcon from '../../icons/component-lib.esm52.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';
import { useModel } from '../../compositions/component-lib.esm15.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm3.js';

//
var script = {
  name: 'Checkbox',
  components: {
    CheckIcon,
    MinusIcon
  },
  props: {
    value: Boolean,
    inputValue: {
      type: Boolean,
      default: null
    },
    hasError: Boolean,
    indeterminate: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: '1rem'
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      color,
      value,
      inputValue,
      size,
      hasError
    } = toRefs(props);
    const theme = useTheme();
    let localValue;
    if (inputValue.value !== null) {
      localValue = inputValue;
    } else {
      localValue = useModel(value, val => emit('input', val));
    }
    const classes = computed(() => {
      return {
        'v-checkbox--has-error': hasError.value,
        'v-checkbox--indeterminate': props.indeterminate
      };
    });
    const styles = computed(() => {
      const themeColor = getThemeColor(hasError.value ? 'error' : color.value, theme.value);
      return {
        '--c-color': themeColor,
        '--c-bg-color': tinycolor(themeColor).setAlpha(0.05).toRgbString(),
        '--c-size': size.value
      };
    });
    const attrs = computed(() => {
      return {
        'aria-checked': props.indeterminate ? 'mixed' : localValue.value,
        'aria-disabled': props.disabled
      };
    });
    return {
      classes,
      styles,
      localValue,
      attrs
    };
  }
};
export { script as default };